export const AdminRole = {
  SUPER_ADMIN: "super_admin",
  ADMIN: "admin",
  EDITOR: "editor",
};

export const UserStatus = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  BLOCKED: "blocked",
  PENDING: "pending",
};

export const ProductCategory = {
  FOOD: "food",
  NON_FOOD: "non-food",
};

export const BlogStatus = {
  DRAFT: "draft",
  PUBLISHED: "published",
  SCHEDULED: "scheduled",
  ARCHIVED: "archived",
};

export const CommentStatus = {
  PENDING: "pending",
  APPROVED: "approved",
  SPAM: "spam",
  TRASHED: "trashed",
};

export const InteractionType = {
  LIKE: "like",
  LOVE: "love",
  CLAP: "clap",
  INSIGHTFUL: "insightful",
  HELPFUL: "helpful",
  SAVE: "save",
  BOOKMARK: "bookmark",
  SHARE: "share",
};

export const CategoryStatus = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  ARCHIVED: "archived",
};

export const NotificationType = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  PROMOTION: "promotion",
  ORDER: "order",
  ACCOUNT: "account",
  SYSTEM: "system",
};

export const NotificationPriority = {
  LOW: "low",
  MEDIUM: "medium",
  HIGH: "high",
  URGENT: "urgent",
};

export const NotificationStatus = {
  UNREAD: "unread",
  READ: "read",
  ARCHIVED: "archived",
  DELETED: "deleted",
};

export const MessageCategory = {
  GENERAL: "general",
  SUPPORT: "support",
  SALES: "sales",
  BILLING: "billing",
  TECHNICAL: "technical",
  FEEDBACK: "feedback",
  COMPLAINT: "complaint",
  OTHER: "other",
};

export const MessagePriority = {
  LOW: "low",
  NORMAL: "normal",
  HIGH: "high",
  URGENT: "urgent",
};

export const MessageStatus = {
  NEW: "new",
  READ: "read",
  REPLIED: "replied",
  FORWARDED: "forwarded",
  RESOLVED: "resolved",
  ARCHIVED: "archived",
  SPAM: "spam",
};

export const RequestStatus = {
  PENDING: "pending",
  CONTACTED: "contacted",
  QUOTED: "quoted",
  APPROVED: "approved",
  ORDERED: "ordered",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
};

export const RequestPriority = {
  LOW: "low",
  MEDIUM: "medium",
  HIGH: "high",
  URGENT: "urgent",
};